import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-porters-page',
  templateUrl: './porters-page.component.html',
  styleUrls: ['./porters-page.component.css']
})
export class PortersPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
